import { render, staticRenderFns } from "./PageFinale.vue?vue&type=template&id=372b40f4&scoped=true"
import script from "./PageFinale.vue?vue&type=script&lang=js"
export * from "./PageFinale.vue?vue&type=script&lang=js"
import style0 from "./PageFinale.vue?vue&type=style&index=0&id=372b40f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b40f4",
  null
  
)

export default component.exports